/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WebhookBaseParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['publicKey', codecString, 'public_key'],
    ['assignmentId', codecNumber, 'assignment_id'],
    ['userId', codecNumber, 'user_id'],
    ['secret', codecString],
    ['defaultBranch', codecString, 'default_branch'],
]));
export class WebhookBase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WebhookBaseParser.decode(input).map(res => new WebhookBase(res));
    }
    static unsafeDecode(input) {
        return WebhookBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WebhookBaseParser.encode(data);
    }
    static schema() {
        return WebhookBaseParser.schema();
    }
}
